import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit, AfterContentChecked, HostListener, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import {Platform} from '@angular/cdk/platform';
import { CardPreviewService, IBrandcardResult, iconsWeblink, IWeblinkIcons, IFeatureContent } from '../../'
import { content } from 'html2canvas/dist/types/css/property-descriptors/content';

@Component({
  selector: 'app-frame-feature',
  templateUrl: './frame-feature.component.html',
  styleUrls: ['./frame-feature.component.scss']
})
export class FrameFeatureComponent implements OnInit, AfterViewInit, AfterContentChecked {
  @Input() mediaData: IBrandcardResult
  @Input() fullPreview: boolean
  @Output() goBackToMainIcons = new EventEmitter<boolean>(false)
  @ViewChild('wrapperElement', {static: true}) wrapperElement: ElementRef
  @ViewChild('headerElement', {static: true}) headerElement: ElementRef

  weblinkIcons: IWeblinkIcons = iconsWeblink
  wrapperHeight: number
  headerHeight: number
  contentHeight: number
  pdfHeight: number
  isBgDarker = false

  constructor(
    private platform: Platform,
    private cardPreviewService: CardPreviewService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngAfterViewInit() {}

  ngAfterContentChecked() {
    this.wrapperHeight = this.wrapperElement.nativeElement.offsetHeight
    this.headerHeight = this.headerElement.nativeElement.offsetHeight
    this.contentHeight = this.wrapperHeight - this.headerHeight
    this.pdfHeight = this.contentHeight - 170
  }

  ngOnInit(): void {
    console.log('%cMediaData', 'font-size:15px;color:yellow;background:purple', this.mediaData)
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.wrapperHeight = this.wrapperElement.nativeElement.offsetHeight
    this.headerHeight = this.headerElement.nativeElement.offsetHeight
    this.contentHeight = this.wrapperHeight - this.headerHeight
    this.pdfHeight = this.contentHeight - 170
  }
  
  goBackToMain() {
    this.goBackToMainIcons.emit(true)
    this.cardPreviewService.setScreen2(false)
  }

  showText(content: IFeatureContent) {
    content.longText = !content.longText
  }

  openMedia(url) {
    if (isPlatformBrowser(this.platformId)) {
      this.cardPreviewService.getWindow().open(url, '_blank')
    }
  }

  get isDeviceIOS() {
    return this.platform.IOS
  }

  get defineBgColorBarTop() {
    return this.cardPreviewService.lightOrDark(this.mediaData.color.bar.bottom)
  }

  modifyPdfUrl(content: any) {
    if (content.isMedia === 'pdf') {
      return `${content.uri}#toolbar=0`
    }
  }

}
